const React = require(`react`)

const preferDefault = m => (m && m.default) || m
let LayoutSwitch
let ThinLayout
let Boostrap
try {
  Boostrap = preferDefault(require('./src/layouts/Boostrap'))
  LayoutSwitch = preferDefault(require('./src/layouts/LayoutSwitch'))
  ThinLayout = preferDefault(require('./src/layouts/ThinLayout'))
} catch (e) {
  console.error(e)
  throw e
}
// eslint-disable-next-line react/prop-types,react/display-name
module.exports = ({ element, props }) => {
  const Layout = (props.pageContext?.layout !== 'thin')
    ? LayoutSwitch
    : ThinLayout
  return (
    <Boostrap {...props}>
      <Layout {...props}>
        {element}
      </Layout>
    </Boostrap>
  )
}